<template>
  <span
    class="mask-from-right relative inline-block"
    :class="[
      $data.class,
      $data.staticClass,
      {
        'flex-1 group-hover:text-white inline-block leading-normal ml-2 max-sm:mb-px py-px sm:font-light text-accent focus-within:text-white ': primary,
      },
    ]"
  >
    <span
      class=" truncate whitespace-pre overflow-hidden r l absolute opacity-0 "
      :class="[
        'transition-opacity-color-fill-bgcolor',
        {
          'opacity-100': value,
        },
        inputClasses,
      ]"
      style="white-space: pre"
      v-if="hideInput"
      >{{ value }}</span
    >
    <base-field
      :class="[
        { inactive: hideInput },
        inputClasses,
        { 'cursor-default pointer-events-none': readonly },
      ]"
      :focus="focus"
      :readonly="readonly"
      :aria-readonly="readonly"
      :type="type"
      :value="value"
      @blur.native="active = false"
      @focus.native="active = true"
      @input="value => $emit('input', value)"
      v-bind="$attrs"
    ></base-field>
  </span>
</template>

<script>
import BaseField from './BaseField'

export default {
  name: `DisplayField`,
  inheritAttrs: false,
  components: {
    BaseField,
  },
  props: {
    focus: {
      type: Boolean,
      default: false,
    },
    value: {
      required: true,
    },
    type: {
      type: String,
      default: `text`,
    },
    inputClasses: {
      type: [String, Array],
      default: ``,
    },
    // applies styles for larger item names
    primary: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    empty() {
      return this.value === ``
    },
    hideInput() {
      return !this.active && !this.empty
    },
  },

  data() {
    return {
      active: false,
    }
  },
}
</script>

<style scoped>
.inactive {
  opacity: 0.001;
}
</style>
